import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  NavigationEnd,
  Router,
  createUrlTreeFromSnapshot
} from '@angular/router';

import { ServerResponse } from '../server/server.tokens';

import { sanitizeUrl } from './index';

/**
 * Compares if previous and current NavigationEnd.urlAfterRedirects are equal
 * @param prevUrl
 * @param currUrl
 */
export function urlAfterRedirectsEqual(
  { urlAfterRedirects: prevUrl }: NavigationEnd,
  { urlAfterRedirects: currUrl }: NavigationEnd
): boolean {
  return sanitizeUrl(prevUrl) === sanitizeUrl(currUrl);
}

/**
 * In SSR environment, disable caching by setting `routeCache.disabled` on response.locals
 * @param response
 */
export function disableSsrCaching(response: ServerResponse): void {
  response.locals.rawEnv.server.routeCache.disabled = true;
}

export const redirectIfFreshNavigationGuard =
  (commands: string[]): CanActivateFn =>
  (route: ActivatedRouteSnapshot): ReturnType<CanActivateFn> => {
    const { navigated } = inject(Router);
    if (navigated) {
      return true;
    }
    return createUrlTreeFromSnapshot(route, commands);
  };
